// import log from 'salvo-lite/log'

class ModalDisplay {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem
    }

    onInit () {
        // Get all elements with data attribute
        const modalTriggers = document.querySelectorAll('[data-modal-display]')
        // Loop through each element, register a click event listener
        modalTriggers.forEach(trigger => {
            trigger.addEventListener('click', e => {
                // Get the ID of the modal to show
                const modalIdentifier = trigger.getAttribute('data-modal-id')
                // Find element in the dom
                const modalToShow = document.getElementById(modalIdentifier)
                // Add class 'active' to display
                modalToShow.classList.add('active')
            })
        })

        // Get all modal elements
        const modals = document.querySelectorAll('.modal')
        // Loop through all modals, register a click event listener
        modals.forEach(modal => {
            modal.addEventListener('click', e => {
                // If parent container or close element
                if (e.target === modal || e.target.classList.contains('modal__close')) {
                    // Remove class 'active' to hide
                    modal.classList.remove('active')
                }
            })
        })
    }
}

export default ModalDisplay



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ModalDisplay.js